import { haveProperty } from '@/utils/';

/**
 *
 * Criação do objecto de token.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * preenchidos na página é que serão enviados. Assim irá permitir usar esta função
 * na adição e na edição deste modelo.
 *
 * @param {Object}  data
 * @param {Object}  helpers
 *
*/
const create = ( data, helpers ) => {
    const token = {
        ...( data.method && { _method: data.method }),
        ...( data.id && { id: data.id }),
        ...( helpers.id && { client_id: helpers.id }),
        ...( data.tokenName && { name: data.tokenName }),
        ...( data.expiresAt && { expires_at: data.expiresAt }),
        ...( haveProperty( data, 'revoked' ) && { revoked: data.revoked })
    };

    return token;
};

const requiredFields = [ { field: 'tokenName', isRequiredOnEdit: false } ];

export {
    create,
    requiredFields
};